import { Fragment, useEffect, useState } from 'react';
import { Container } from '@/components/container';
import {
    Toolbar,
    ToolbarDescription,
    ToolbarHeading,
    ToolbarPageTitle,
} from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { enqueueSnackbar } from 'notistack';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { CPSPromptsContent } from './CPSPromptsContent.tsx';
import { CPSPromptData } from "@/pages/buddy/types/CPSPromptData";

const CPSPromptsPage = () => {
    const [cpsPrompts, setCpsPrompts] = useState<CPSPromptData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const { tab } = useParams<{ tab?: string }>();
    const [activePage, setActivePage] = useState<string>(tab || 'overview');

    const API_CPS_PROMPTS = `${import.meta.env.VITE_APP_API_URL}/admin/cps-prompts`;

    const fetchCpsPrompts = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get<CPSPromptData[]>(API_CPS_PROMPTS, {
                headers: { Accept: 'application/json' },
            });
            setCpsPrompts(data);
        } catch (err) {
            enqueueSnackbar(`Failed to fetch CPS prompts: ${err}`, { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCpsPrompts();
    }, []);

    return (
        <Fragment>
            <PageNavbar />

            <Container>
                <Toolbar>
                    <ToolbarHeading>
                        <ToolbarPageTitle />
                        <ToolbarDescription>
                            Review and manage all CPS prompts. You can view details and delete entries.
                        </ToolbarDescription>
                    </ToolbarHeading>
                </Toolbar>
            </Container>

            <Container>
                <CPSPromptsContent
                    cpsPrompts={cpsPrompts}
                    loading={loading}
                />
            </Container>
        </Fragment>
    );
};

export { CPSPromptsPage };
